import { InspectionTemplateDraft } from "@/shared/models/Inspection";

export type TemplateModalMode =
	| "create"
	| "revision"
	| "duplicate"
	| "update"
	| "correct"
	| "view";

export type TemplateModalTarget = {
	openedAt: number;
	mode: TemplateModalMode;
	draft: InspectionTemplateDraft;
	sectionName: string;
};

export const TEMPLATE_MODAL_TITLES: Record<TemplateModalMode, string> = {
	create: "NEW INSPECTION TEMPLATE",
	revision: "NEW DRAFT",
	duplicate: "DUPLICATE INSPECTION TEMPLATE",
	update: "EDIT DRAFT",
	correct: "EDIT PUBLISHED REVISION",
	view: "REVISION",
};
